export default __webpack_public_path__ + "1a1f8921437b6145a8dd0e5817fd7932.jpg";